import { Selecting, useToastProvider } from '@qualio/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentStatus } from '../../../../../../../../api/model/document';
import { CredentialConfirmationModal } from '../../../../../../CredentialConfirmationModal/index';
import { useTableDataInvalidation } from '../../../../hooks/useTableDataInvalidation';
import {
  hasAllowedStatusesForAction,
  hasRequiredPermissionsForAction,
} from '../../../BulkActions';
import { BulkActionButton } from '../../BulkActionButton/index';
import { handleStatusChange } from '../ChangeStatusService';
import {
  ChangeStatusButtonProps,
  IsChangeStatusActionAllowedCallback,
} from '../types';

export const MakeEffectiveButton = (props: ChangeStatusButtonProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onClose = () => setIsModalOpen(false);
  const selection = Selecting.useSelectionMaybe();
  const { invalidate } = useTableDataInvalidation();

  const buttonActionLabel = t('buttons.makeEffective');
  const modalHeading = t('modals.makeDocumentEffective');
  const modalText = t('modals.enterDigitalSignatureMakeEffective');

  const toastActionStringActive = t('buttons.makeEffective').toLowerCase();
  const toastActionStringPassive = t('success.successfullyMadeEffective')
    .toLowerCase()
    .replace('successfully ', '')
    .replace(' document effective', ' effective');

  const handleMakeEffective = async (
    email: string,
    password: string,
    comment?: string,
  ) => {
    await handleStatusChange(
      props.selectedDocuments,
      { status: DocumentStatus.Effective, email, password, comment },
      selection?.setSelection as any,
      showToast,
      toastActionStringActive,
      toastActionStringPassive,
    );
    setIsModalOpen(false);
    void invalidate(props.currentTab);
  };

  const canMakeEffective: IsChangeStatusActionAllowedCallback = (
    user,
    statuses,
    _activeTab,
    requiredPermissions,
  ) => {
    if (
      !hasRequiredPermissionsForAction(requiredPermissions, user.permissions)
    ) {
      return false;
    }
    return hasAllowedStatusesForAction([DocumentStatus.Approved], statuses);
  };

  return (
    <>
      <BulkActionButton
        {...props}
        isActionAllowed={canMakeEffective}
        onClick={() => setIsModalOpen(true)}
      />
      <CredentialConfirmationModal
        isOpen={isModalOpen}
        onCloseModal={onClose}
        handleStatusChange={handleMakeEffective}
        modalText={modalText}
        modalHeading={modalHeading}
        buttonActionLabel={buttonActionLabel}
      />
    </>
  );
};
